import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import api from "@/lib/apiClient";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ loading: true, sub: null });
  const sessionId = params.get("session_id");

  useEffect(() => {
    if (!sessionId) { setState({ loading: false, sub: null }); return; }
    let tries = 0;
    const poll = () => {
      api.get(`/b2b/subscription/status/${sessionId}`).then((r) => {
        if (r.data.status === "active" || tries >= 5) setState({ loading: false, sub: r.data });
        else { tries++; setTimeout(poll, 2000); }
      }).catch(() => setState({ loading: false, sub: null }));
    };
    poll();
  }, [sessionId]);

  return (
    <div className="min-h-[70vh] grid place-items-center bg-slate-50 px-4" data-testid="billing-success">
      <div className="bg-white rounded-2xl shadow-lg p-10 text-center max-w-md">
        {state.loading ? (
          <><Loader2 className="w-10 h-10 animate-spin text-teal-600 mx-auto" /><p className="mt-4 text-slate-600">Confirming your subscription…</p></>
        ) : state.sub?.status === "active" ? (
          <><CheckCircle2 className="w-14 h-14 text-teal-600 mx-auto" /><h1 className="font-display text-2xl font-bold text-blue-950 mt-4">{state.sub.plan_name} is active!</h1><p className="text-slate-600 mt-2">${state.sub.amount}/{state.sub.interval}. Your organization now has full access.</p><Button asChild className="mt-6 bg-blue-900"><Link to="/dashboard" data-testid="billing-continue">Go to my dashboard</Link></Button></>
        ) : (
          <><XCircle className="w-14 h-14 text-amber-500 mx-auto" /><h1 className="font-display text-2xl font-bold text-blue-950 mt-4">Payment not yet confirmed</h1><p className="text-slate-600 mt-2">If you completed checkout, it may take a moment. You can refresh or contact us.</p><Button asChild variant="outline" className="mt-6"><Link to="/pricing">Back to pricing</Link></Button></>
        )}
      </div>
    </div>
  );
}
